import { useQuery } from '@tanstack/react-query';

import { getSyncJobs } from '@/api/sync/get-sync-jobs';
import { pollInterval } from '@/lib/poll-interval';

import { syncKeys } from './query-keys';

/** `enabled` is false for someone who may not read it. Polls faster while any job is running. */
export const useSyncJobs = (enabled = true) =>
  useQuery({
    queryKey: syncKeys.jobs(),
    queryFn: getSyncJobs,
    enabled,
    refetchInterval: (query) =>
      pollInterval(query.state.data?.jobs.some((job) => job.running) ?? false),
  });
